import {
  NgFor,
  NgIf,
} from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';

import { DSpaceObject } from '../../../../../../../../app/core/shared/dspace-object.model';
import { MetadataValue } from '../../../../../../../../app/core/shared/metadata.models';

/**
 * BfS: renders the subjects (Schlagwörter) of an item as clickable badges next to the
 * entity type badge. Each badge links to the search page with the subject facet
 * (`f.<filterName>=<value>,equals`) pre-selected.
 */
@Component({
  selector: 'ds-subject-badges',
  templateUrl: './subject-badges.component.html',
  styleUrls: ['./subject-badges.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, RouterLink, TranslateModule],
})
export class SubjectBadgesComponent {

  /**
   * The item to render the subjects for
   */
  @Input() object: DSpaceObject;

  /**
   * Metadata fields containing the subjects
   */
  @Input() fields: string[] = ['dc.subject', 'dc.subject.other'];

  /**
   * Name of the search filter (facet) to pre-select
   */
  @Input() filterName = 'subject';

  constructor(
    protected translateService: TranslateService,
  ) {
  }

  /**
   * Distinct subject values (duplicates across dc.subject / dc.subject.other are shown once).
   * Only values in the current interface language are shown; if none has that language
   * (e.g. older items without language code), all values are shown.
   */
  get subjects(): string[] {
    const all: MetadataValue[] = this.object?.allMetadata(this.fields) ?? [];
    const currentLang = this.translateService.currentLang;
    const matching = all.filter((v) => v.language === currentLang);
    const values = (matching.length > 0 ? matching : all).map((v) => v.value?.trim());
    return Array.from(new Set(values.filter((v) => !!v)));
  }

  getQueryParams(value: string): Record<string, string> {
    return { [`f.${this.filterName}`]: `${value},equals` };
  }
}
